import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LdsComponentsModule } from '@liberty-financial/ng-components';
import { LdsCoreModule } from '@liberty-financial/ng-core';
import { TagInputComponent } from './tag-input.component';
import { FormFieldsModule } from '@shared/components/form-fields/form-fields.module';

@NgModule({
  declarations: [TagInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LdsCoreModule,
    LdsComponentsModule,
    FormFieldsModule
  ],
  exports: [TagInputComponent]
})
export class TagInputModule {}

